// Bill Summary Chart constants
export const FIELDS = [
  "energyCharges",
  "energyRevenue",
  "demandCharges",
  "fixedCharges",
  "subscribedCharges",
  "penaltyCharges",
];

export const COLORS = [
  "#1565c0", // blue
  "#1e88e5",
  "#42a5f5",
  "#90caf9",
  "#b0bec5",
  "#78909c",
  "#cfd8dc",
  "#eceff1", // light grey
];
export const AFTER_BAR_COLORS = [
  "#3dcd58",
  "#bbb",
  "#bbb",
  "#bbb",
  "#bbb",
  "#bbb",
  "#bbb",
  "#bbb",
  "#bbb",
  "#bbb",
  "#bbb",
  "#bbb",
];


export const FIELD_LABELS = {
  energyCharges: "Energy Charges",
  energyRevenue: "Energy Revenue",
  demandCharges: "Demand Charges",
  fixedCharges: "Fixed Charges",
  subscribedCharges: "Subscribed Charges",
  penaltyCharges: "Penalty Charges",
};

export const LEGEND_FIELDS = [
  ...FIELDS.map((f) => ({
    key: `before-${f}`,
    label: `${FIELD_LABELS[f]} (Before)`,
    group: "before",
    field: f,
  })),
  ...FIELDS.map((f) => ({
    key: `after-${f}`,
    label: `${FIELD_LABELS[f]} (After)`,
    group: "after",
    field: f,
  })),
];
